import { render } from "./DrillHoleEdgeTypeAround.vue?vue&type=template&id=fa6a2064"
import script from "./DrillHoleEdgeTypeAround.vue?vue&type=script&lang=js"
export * from "./DrillHoleEdgeTypeAround.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__